/**
 * Shared class-name constants for the floating dark-glass toolbars that sit over
 * the 3D viewports (event planner, cinematic studio, cinema/flythrough controls).
 *
 * Kept in a non-component module so `ToolbarButton` can stay component-only
 * (react-refresh fast-refresh requirement).
 */

export type ToolbarAccent = 'sky' | 'emerald' | 'amber' | 'fuchsia'

/** Shared base — fixed h-9, consistent padding/typography/icon rhythm. */
export const TOOLBAR_BASE =
  'pointer-events-auto flex h-9 items-center gap-1.5 rounded-lg border px-2.5 ' +
  'text-xs font-semibold backdrop-blur-sm transition-colors'

/** Neutral glass state shared by every inactive toggle. */
export const TOOLBAR_OFF =
  'border-white/10 bg-black/60 text-white/60 hover:bg-white/5 hover:text-white'

/** Accent (active) class strings — full literals so Tailwind keeps them. */
export const TOOLBAR_ON: Record<ToolbarAccent, string> = {
  sky: 'border-sky-400/40 bg-sky-500/20 text-sky-100 hover:bg-sky-500/30',
  emerald: 'border-emerald-400/40 bg-emerald-500/20 text-emerald-100 hover:bg-emerald-500/30',
  amber: 'border-amber-400/50 bg-amber-500/25 text-amber-100 hover:bg-amber-500/30',
  fuchsia: 'border-fuchsia-400/40 bg-fuchsia-500/20 text-fuchsia-200 hover:bg-fuchsia-500/30',
}
